module.exports = __webpack_public_path__ + "fonts/ManropeSemibold.81da8f1.woff";